
import { Line } from "vue-chartjs";

const SUMBU_Y = "tren-y";
const TARGET = 85;
const WARNA_TARGET = "#2E7D32";

export default {
  extends: Line,
  props: {
    labels: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: this.series.map((s: any) => ({
          label: s.label,
          data: s.data,
          borderColor: s.color,
          backgroundColor: s.color,
          pointStyle: s.pointStyle,
          pointRadius: 5,
          pointHoverRadius: 7,
          borderWidth: 2,
          fill: false,
          spanGaps: false,
          lineTension: 0
        }))
      };
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
          labels: { usePointStyle: true, padding: 16 }
        },
        scales: {
          yAxes: [
            {
              id: SUMBU_Y,
              ticks: {
                min: 0,
                max: 100,
                stepSize: 20,
                callback: (value: number) => value + "%"
              }
            }
          ]
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: (item: any, data: any) => {
              const dataset = data.datasets[item.datasetIndex];
              const nilai = dataset.data[item.index];
              const teks =
                nilai === null || nilai === undefined
                  ? "tidak ada data"
                  : String(nilai).replace(".", ",") + "%";
              return `${dataset.label}: ${teks}`;
            }
          }
        }
      }
    };
  },
  mounted() {
    this.addPlugin({
      beforeDatasetsDraw(chart: any) {
        const yAxis = chart.scales[SUMBU_Y];
        if (!yAxis) return;
        const { left, right } = chart.chartArea;
        const y = yAxis.getPixelForValue(TARGET);
        const ctx = chart.ctx;
        ctx.save();
        ctx.setLineDash([6, 4]);
        ctx.strokeStyle = WARNA_TARGET;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(left, y);
        ctx.lineTo(right, y);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = WARNA_TARGET;
        ctx.font = "10px sans-serif";
        ctx.textAlign = "right";
        ctx.fillText(`Target ${TARGET}%`, right - 4, y - 4);
        ctx.restore();
      }
    });
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};
